import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import validate from '../../../../validations';

export default function useValidations() {
  const { t } = useTranslation();

  return useMemo(
    () => ({
      name: validate.composeValidators(
        validate.required(),
        validate.noLongerThan(50, t('noLongerThan', { length: 50 })),
        validate.fullNameValidation(t('specialCharactersOrNumbersNotAllowed')),
      ),
      lastName: validate.composeValidators(
        validate.noLongerThan(50, t('noLongerThan', { length: 50 })),
        validate.fullNameValidation(t('specialCharactersOrNumbersNotAllowed')),
      ),
      password: validate.composeValidators(
        validate.required(
          t('requiredField2', {
            fieldName: t('password').toLowerCase(),
          }),
        ),
        validate.passwordFieldsValidation(),
      ),
    }),
    [t],
  );
}
